// The built bundle is served by Django from the same origin (production and
// staging alike), so an unset REACT_APP_BACKEND_URL means "this origin". Local
// dev keeps pointing at the API server through .env / .env.development.local.
const SAME_ORIGIN = typeof window !== "undefined" && window.location ? window.location.origin : "";
export const BASE_URL = process.env.REACT_APP_BACKEND_URL || SAME_ORIGIN;
export const API_BASE_URL = `${BASE_URL}/api/users`;
export const CACHE_SHARE_BASE_URL = process.env.REACT_APP_CACHE_SHARE_URL || `${BASE_URL}/api/users`;
export const CLOUDINARY_CLOUD_NAME = process.env.REACT_APP_CLOUDINARY_CLOUD_NAME;
// Brandfetch Logo CDN client id (public, client-side by design).
export const BRANDFETCH_CLIENT_ID = process.env.REACT_APP_BRANDFETCH_CLIENT_ID || '1exidxdJqaVZR8U4gFWgn';

export const expiresInSeconds = 7200; // assume token valid for 2 hours (check your backend's config)

// Where an athlete lands (log in, Google sign-in, the "/" route, the end of
// onboarding, the Athlete Mode wordmark): My Profile, the first Athlete Mode
// tab since the 9/29 review. /athlete/home stays the Dashboard tab.
export const ATHLETE_LANDING = '/athlete/profile';

// `color` is a V2 badge fill for a role pill: the soft neutral, with the
// orange tint for coaches and recruiters.
export const routePathsByRole = {
  "IS_BRAND_AGENCY": {
    'value': 1,
    'url': '/brand/home',
    'role': 'Brand/Agency',
    'color': 'bg-bm-mutedbg text-bm-n700',
  },
  "IS_ATHLETE": {
    'value': 2,
    'url': ATHLETE_LANDING,
    'role': 'Athlete',
    'color': 'bg-bm-mutedbg text-bm-n700',
  },
  "IS_COACH": {
    'value': 3,
    'url': '/coach/home',
    'role': 'Coach',
    'color': 'bg-bm-orange/10 text-bm-orange',
  },
  "IS_INTERN": {
    'value': 4,
    'url': '/users',
    'role': 'Intern',
    'color': 'bg-bm-mutedbg text-bm-n700',
  },
  "IS_CACHE_AI": {
    'value': 5,
    'url': '/business/dashboard',
    'role': 'Cache AI',
    'color': 'bg-bm-mutedbg text-bm-n700',
  },
  "IS_RECRUITER_SCOUT": {
    'value': 6,
    'url': '/business/dashboard',
    'role': 'Recruiter/Scout',
    'color': 'bg-bm-orange/10 text-bm-orange',
  },
  "IS_AD_PD": {
    'value': 7,
    'url': '/business/dashboard',
    'role': 'AD/PD',
    'color': 'bg-bm-mutedbg text-bm-n700',
  },
  "IS_ADMIN": {
    'value': 8,
    'url': '/business/dashboard',
    'role': 'Admin',
    'color': 'bg-bm-mutedbg text-bm-n700',
  },
  // Parents, guardians and trainers: My Circle in the supporter shell.
  "IS_SUPPORTER": {
    'value': 9,
    'url': '/supporter/circle',
    'role': 'Supporter',
    'color': 'bg-bm-mutedbg text-bm-n700',
  },
  // Agents / representatives (Rep Mode). They get a Rep ID at signup that
  // athletes enter in My Circle to link them.
  "IS_REP": {
    'value': 10,
    'url': '/rep/home',
    'role': 'Rep / Agent',
    'color': 'bg-bm-mutedbg text-bm-n700',
  },
}

// Profile-completion fields — must mirror backend calculate_profile_completion
// (users/utils.py). The old wizard fields Years On This Team / Years Playing
// Sport were replaced by Graduation Year + Level Of Play and aren't editable
// anymore; keeping them here pinned athletes below 100% with nothing to fill.
export const fieldsToCheck = {
  'avatar': 'Avatar',
  'name': 'First Name',
  'surname': 'Last Name',
  'primarySport': 'Primary Sport',
  'currentTeam': 'Current Team',
  'position': 'Position',
  'gradYear': 'Graduation Year',
  'levelOfPlay': 'Level Of Play'
};

// Pricing Constants
export const PRICING = {
  TIER1: {
    MONTHLY: 10.00,
    ANNUAL: 114.00, // 10 * 12 * 0.95 (5% discount)
    FEATURES: ['Cachescore', 'Cachevalue'],
    NAME: 'Basic'
  },
  TIER2: {
    MONTHLY: 20.00,
    ANNUAL: 228.00, // 20 * 12 * 0.95 (5% discount)
    FEATURES: ['Cachescore', 'Cachevalue', 'Optimization', 'Peer-to-peer features', 'Team analytics'],
    NAME: 'Professional'
  },
  ENTERPRISE: {
    NAME: 'Enterprise',
    DESCRIPTION: 'Custom pricing - Let\'s talk',
    FEATURES: ['All Professional features', 'Custom solutions', 'Dedicated support']
  }
};

// For backward compatibility
export const athletePrice = PRICING.TIER1.MONTHLY;
export const businessPrice = PRICING.TIER2.MONTHLY;
